<template>
  <div class="standing">
    <div class="lading_conter_search" id="lading_conter_search-carStatistics">
      <my-search-query ref="queryList" :fromList="fromList" :isShow="true" @queryEven="getTableParams"/>
    </div>
    <div class="standing-bar">
      <el-button type="primary" size="small" icon="el-icon-upload" @click="$refs.spTable.exportExcel()">导出</el-button>
    </div>
    <div class="lading_conter">
      <div class="lading_table">
        <div class="lading_conter_table">
          <sp-table
            ref="spTable"
            :parentTableData.sync="tableData"
            :parentCol.sync="tableDataCol"
            :dragDrop="true"
            show-summary
            :summary-method="getSummaries"
            :summary-data="summaryData"
            :row-class-name="tableRowClassName"
            @row-dblclick="dblclickFn"
            height="100%">
            <el-table-column align="center" type="selection" class="selection"></el-table-column>
            <el-table-column align="center" type="index" width="50" label="序号" class-name="index"></el-table-column>
            <sp-table-column :align="item.titleAlignment" v-for="(item, index) in tableDataCol" :key="index"
                             :width="item.displayWidth"
                             sortable
                             :prop="tableDataCol[index].fieldName"
            >
              <template slot="header">
                <p>{{item.fieldAlias}}</p>
              </template>
              <template v-slot="{ scope }">
                <div class="span" :style="{textAlign: item.alignment}">
                  {{scope.row[tableDataCol[index].fieldName]}}
                </div>
              </template>
            </sp-table-column>
          </sp-table>
        </div>
      </div>
    </div>
    <flow :pntName="pntName" :show="flowVisible" @close="()=>{flowVisible=false}"></flow>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex';
  import {spTable, spTableColumn} from '@/components/sptable';
  import mySearchQuery from '../../adminService/comm/searchQuery';
  import flow from './flow.vue';
  import dayjs from 'dayjs';

  const _ = require('lodash');

  export default {
    name: 'shipInOutQuery',
    components: {
      spTable,
      spTableColumn,
      mySearchQuery,
      flow
    },
    data() {
      return {
        tableData: [],
        heightSearch: 0,
        bargain: [],
        getOutCarTankList: [],
        getTGuestNumList: [],
        getRefGoodsList: [],
        getRefGuestsList: [],
        formInline: {},
        tableDataCol: [],
        getBlno: [],
        summaryData:'',
        systemConfig183: '',
        flowVisible: false,
        pntName: ''
      };
    },
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
        listWebCusOutGoods: 'dictionary/shipInOutAction',
      }),
      fromList() {
        let arr = [
          {
            label: '产品',
            key: 'goodsId',
            type: 'select',
            showDialog: true,
            tips: '...',
            dialog: 'showGoodsID',
            valData: this.getRefGoodsList,
            labelVal: 'Name',
            value: 'GoodsID',
            multiple: false,
            colSpan: 6
          },
          {
            label: '客户',
            key: 'guestId',
            type: 'select',
            showDialog: true,
            tips: '...',
            dialog: 'showGuestsID',
            valData: this.getRefGuestsList,
            labelVal: 'Name',
            value: 'GuestID',
            multiple: false,
            colSpan: 6
          },
          {
            label: '开始时间',
            key: 'beginDate',
            type: 'timeSelect',
            default: `${this.$utils.getTimeByDay(new Date(),7)} 00:00:01`,
            colSpan: 6
          },
          {
            label: '结束时间',
            key: 'endDate',
            type: 'timeSelect',
            default: `${this.$utils.getTimeByDay(new Date().setDate(new Date().getDate() + 7))} 23:59:59`,
            colSpan: 6
          },
        ];
        return arr;
      },
    },
    created() {
      //this.getOutCarTankAPI();
      this.getRefGoodsAPI();
      this.getRefGuestsAPI();
      // this.getTGuestNum();
      this.getlistWebCusOutGoods();
    },
    mounted() {
      // this.getTableParams(false);
      // this.getSystemConfig('183')
      this.flowVisible = false
    },
    methods: {
      dblclickFn(row){
        this.pntName = row.LiveFlowID
        this.setOpen()
      },
      setOpen() {
        this.$nextTick(() => {
          this.flowVisible = true
        })
      },
      initColor(item) {
        const Type = {
          1: '#0000FF',
        };
        // if (Type[item.Type]) return Type[item.Type];
        return '#333'
      },
      tableRowClassName({row, rowIndex}) {
        if (row.TankID === '总计') {
          return 'sum'
        }
        if (row.TankID === '小计') {
          return 'subtotal'
        }
        if (row.TankID === '累计') {
          return 'accumulative'
        }

        return ''
      },
      ...mapActions({
        getlistWebCusOutGoods: 'dictionary/getShipInOutAction',
      }),
      licenseNumberSelectionChange() {

      },
      // 台帐参数处理
      getTableParams(start) {
        let params = {
          beginDate: '2019-01-01 00:00:00',
          endDate: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
        };
        if (!start) {
          let fromData = _.cloneDeep(this.$refs.queryList.fromData);
          for (let i in fromData) {
            if (!fromData[i] || typeof fromData[i] === 'object') {
              delete fromData[i];
            }
          }
          Object.assign(params, fromData);
        }
        this.listAccountBooksAPI(params);
      },
      listAccountBooksAPI(params) {
        this.$services.postLoading({
          type: 'BOHUA',
          url: 'webQryShipInOut',
          params: {
            data: JSON.stringify(params)
          },
        }).then(res => {
          this.tableData = res.bean;
          this.$refs.spTable.initTable();
        });
      },
      getSystemConfig(identityId) {
        // this.$services.postLoading({
        //   type: 'BUSINESS',
        //   url: 'getGet_SystemConfig',
        //   params: {
        //     accountId: this.userInfor.accountId,
        //     identityID: identityId
        //   },
        // }).then(res => {
        //   identityId === '183' ? this.systemConfig183 = res.bean[0].Value : '';
        // });
      },
      getSummaries(param) {
        const countList = ['Number'];
        const countObj = {
          Number: {
            unit: ' ',
          }
        };
        const {columns, data} = param;
        let sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (countObj[column.property]) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                }
                return prev;
              }, 0);
              sums[index] += countObj[column.property].unit;
            }
            else {
              sums[index] = '';
            }
          }
        });
        this.summaryData = [countList, sums];
        return sums;
      },
      // 产品弹出选择
      getRefGoodsAPI() {
        this.$services.postLoading({
          type: 'BOHUA',
          url: 'listGoodsDic',
        }).then(res => {
          this.getRefGoodsList = res.bean;
        });
      },
      getRefGuestsAPI() {
        this.$services.postLoading({
          type: 'BOHUA',
          url: 'listGuestDic',
        }).then(res => {
          this.getRefGuestsList = res.bean;
        });
      },
      addColData(callback) {
        this.licenseNumberList.push(JSON.parse(JSON.stringify(
          Object.assign(this.licenseNumberOriginData, {
            uid: this.$utils.getUid(),
            id: this.licenseNumberList.length + 1
          })
        )));
        this.$nextTick(() => {
          if (typeof callback === 'function') callback();
        });
      },
      initCol() {
        this.listWebCusOutGoods.length > 0
        && (this.tableDataCol = this.listWebCusOutGoods.map(itme => {
            let info = itme;
            info.field = itme.fieldName;
            info.title = itme.fieldAlias;
            info.width = itme.displayWidth;
            return info;
          })
        );
      },
    },
    watch: {
      listWebCusOutGoods() {
        this.initCol();
      },
      tableDataCol(val) {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
    }
  };
</script>
<style lang="scss">
  .standing {
    flex: 1;
    display: flex;
    flex-direction: column;
    .sum {
      background-color: rgba(254, 240, 240, 1);
      color: #F56C6C !important;
    }
    .accumulative {
      background-color: rgba(253, 246, 236, 1);
      color: #E6A23C !important;
    }
    .subtotal {
      background-color: rgba(240, 249, 235, 1);
      color: #67C23A !important;
    }
  }
</style>
